import { MuiThemeProvider } from '@material-ui/core';
import client from 'graphql/client';
import moment from 'moment';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { theme } from 'styles/theme';
import App from 'views/app';

moment.locale('es');

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <BrowserRouter>
            <ApolloProvider client={client}>
                <App />
            </ApolloProvider>
        </BrowserRouter>
    </MuiThemeProvider>,
    document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./index.js